import { render } from "./HeaderNotificationMenu.vue?vue&type=template&id=12dfdbb4&scoped=true"
import script from "./HeaderNotificationMenu.vue?vue&type=script&lang=js"
export * from "./HeaderNotificationMenu.vue?vue&type=script&lang=js"

import "./HeaderNotificationMenu.vue?vue&type=style&index=0&id=12dfdbb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dfdbb4"]])

export default __exports__